import { Card } from "../../../../../components/Card";
import { NavigationTabs } from "../../../../../components/NavigationTabs";
import scopeThreePreviewRegistry from "./scopeThreePreviewRegistry";
import { t } from "i18next";
import { SCOPE_3_CATEGORIES_KEYS, SCOPE_3_CATEGORIES_SEQUENCE } from "./const";

function mapData(categories, reportId) {
  const elements = [];

  Object.keys(SCOPE_3_CATEGORIES_KEYS).forEach(key => {
    elements.push({
      component: scopeThreePreviewRegistry.resolve(key),
      data: categories[key],
      reportId: reportId,
      id: key,
      name: `Category ${SCOPE_3_CATEGORIES_SEQUENCE.indexOf(key) + 1}`,
      customTabPanelTitle: t(`reportsPage.scopeThree.categories.${key}`),
      customTabListSubTitle: t(`reportsPage.scopeThree.categories.${key}`).split(":")[1]
    });
  });
  return elements;
}

function ScopeThree({ data, reportId }) {
  const categoryElements = mapData(data, reportId);

  return (
    <Card boxShadow="xs">
      <NavigationTabs
        elements={categoryElements}
        tabTitle={"Category"}
        subTitleAttribute={"name"}
        navTabPanelStyles={{paddingInlineStart: 5, paddingInlineEnd: 0}}
      />
    </Card>
  );
}

export default ScopeThree;